import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SearchResults from '@/views/SearchResults.vue';
import WeixinPage from '@/views/erweima/weixin.vue';
import PdfViewer from '@/views/cultureBuilding/PdfViewer.vue';
import guizhang_pdfviewer from '@/views/guizhangzhidu/PdfViewer.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 关于协会、学会简介
  {
    path: '/aboutview',
    name: 'aboutview',
    component: () => import('../views/AboutView/index.vue'),
    children: [
      {
        path: "/learnabout",
        component: () => import("@/views/AboutView/learnAbout/index.vue"),
        meta: { hidden: true },
        children: [
          {
            path: "/learnaboutIntroduction",
            component: () => import("@/views/AboutView/learnAbout/learnAboutIntroduction.vue"),
            meta: { hidden: true },
          },
          {
            path: "/learnaboutRules",
            component: () => import("@/views/AboutView/learnAbout/learnAboutRules.vue"),
            meta: { hidden: true },
          },
          {
            path: "/learnaboutCouncil",
            component: () => import("@/views/AboutView/learnAbout/learnAboutCouncil.vue"),
            meta: { hidden: true },
          },
        ]
      },
      {
        path: "/xiehuiabout",
        component: () => import("@/views/AboutView/xiehuiAbout/index.vue"),
        meta: { hidden: true },
        children: [
          {
            path: "/xiehuiaboutIntroduction",
            component: () => import("@/views/AboutView/xiehuiAbout/xiehuiAboutIntroduction.vue"),
            meta: { hidden: true },
          },
          {
            path: "/xiehuiaboutRules",
            component: () => import("@/views/AboutView/xiehuiAbout/xiehuiAboutRules.vue"),
            meta: { hidden: true },
          },
          {
            path: "/xiehuiaboutCouncil",
            component: () => import("@/views/AboutView/xiehuiAbout/xiehuiAboutCouncil.vue"),
            meta: { hidden: true },
          },
        ]
      },
    ]
  },
  /** 党建文化建设 */
  {
    path: '/cultureBuilding',
    name: 'cultureBuilding',
    // component: () => import('../views/cultureBuilding/index.vue'),
    children: [
      {
        path: '/dangjian',
        name: 'dangjian',
        component: () => import('../views/cultureBuilding/index.vue'),
      },
      {
        path: '/dangzhang',
        name: 'dangzhang',
        component: () => import('../views/cultureBuilding/dangzhang.vue'),
      },
    ]
  },
  /** 政策法规 */
  {
    path: '/policyAndfg',
    name: 'policyAndfg',
    component: () => import('../views/policyAndfg/index.vue')
  },
  /** 规章制度 */
  {
    path: '/guizhangzhidu',
    name: 'guizhangzhidu',
    component: () => import('../views/guizhangzhidu/index.vue'),
    children: [
      {
        path: '/learnRules',
        name: 'learnRules',
        component: () => import('../views/guizhangzhidu/learnRules/index.vue'),
      },
      {
        path: '/xiehuiRules',
        name: 'xiehuiRules',
        component: () => import('../views/guizhangzhidu/xiehuiRules/index.vue'),
      },
    ]
  },
  /** 分支机构 */
  {
    path: '/branch',
    name: 'branch',
    component: () => import('../views/Branch/index.vue'),
    children: [
      {
        path: "/chairman",
        component: () => import("@/views/Branch/learnBranch/chairman.vue"),
        meta: { hidden: true },
      },
      {
        path: "/listOfMembers",
        name: "listOfMembers", // 确保有这个名称
        component: () => import("@/views/Branch/learnBranch/listOfMembers.vue"),
        meta: { hidden: true },
      },
      {
        path: "/learn_branch",
        component: () => import("@/views/Branch/learn_branch.vue"),
        meta: { hidden: true },
      },
      {
        path: "/xiehui_branch",
        component: () => import("@/views/Branch/xiehui_branch.vue"),
        meta: { hidden: true },
      },
      {
        path: "/workDynamics",
        component: () => import("@/views/Branch/learnBranch/workDynamics.vue"),
        meta: { hidden: true },
      },
      {
        path: "/studyGroup",
        component: () => import("@/views/Branch/learnBranch/studyGroup.vue"),
        meta: { hidden: true },
      },
      // ]
      // },
    ]
  },
  // 文章内容
  {
    path: '/article',
    name: 'article',
    component: () => import('../views/dowloadDetail/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  /** 事务公开 */
  {
    path: '/workOpen',
    name: 'workopen',
    component: () => import('../views/workOpen/index.vue'),
    children: [
      {
        path: "/learnOpen",
        component: () => import("@/views/workOpen/learnOpen/index.vue"),
        meta: { hidden: true },
      },
      {
        path: "/xiehuiOpen",
        component: () => import("@/views/workOpen/xiehuiOpen/index.vue"),
        meta: { hidden: true },
      },
    ]
  },
  /** 通知公告 */
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/notice/index.vue'),
    children: [
      {
        path: "/learnnotice",
        component: () => import("@/views/notice/learnNotice/notice.vue"),
      },
      {
        path: "/learnwork",
        component: () => import("@/views/notice/learnNotice/work.vue"),
      },
      {
        path: "/xiehuinotice",
        component: () => import("@/views/notice/xiehuiNotice/notice.vue"),
      },
      {
        path: "/xiehuiwork",
        component: () => import("@/views/notice/xiehuiNotice/work.vue"),
      },
    ]
  },
  /** 学术交流 */
  {
    path: '/academicExchange',
    name: 'academicExchange',
    component: () => import('../views/xueshujiaoliu/index.vue'),
  },
  /** 科普园地 */
  {
    path: '/spreadField',
    name: 'spreadField',
    // component: () => import('../views/spreadField/index.vue'),
    children: [
      {
        path: "/danao",
        component: () => import("@/views/spreadField/index.vue"),
        meta: { hidden: true },
      },
      {
        path: "/shuimian",
        component: () => import("@/views/spreadField/shuimian.vue"),
        meta: { hidden: true },
      },
    ]
  },
  /** 下载专区 */
  {
    path: '/downloadZone',
    name: 'downloadZone',
    component: () => import('../views/downloadZone/index.vue'),
    children: [
      {
        path: "/learnZone",
        component: () => import("@/views/downloadZone/learnZone/index.vue"),
        meta: { hidden: true },
      },
      {
        path: "/xiehuiZone",
        component: () => import("@/views/downloadZone/xiehuiZone/index.vue"),
        meta: { hidden: true },
      },
    ]
  },
  // 卫生强基
  {
    path: '/weisheng',
    name: 'weisheng',
    component: () => import("../views/weisheng/jiceng.vue"),
  },
  // 大讲堂
  {
    path: '/jiangtang',
    name: 'jiangtang',
    component: () => import("../views/dajiangtang/jiangtang.vue"),
  },
  /** 会员系统
   * 1、登录、注册页面
   * 2、用户管理页面
   */
  {
    path: '/menberLogin',
    name: 'menberLogin',
    component: () => import('../views/menberWindow/loginPage/index.vue')
  },
  // {
  //   path: '/system',
  //   name: 'system',
  //   component: () => import('../views/menberWindow/system/index.vue')
  // },
  // 个人中心
  {
    path: '/system',
    name: 'system',
    component: () => import('../views/menberWindow/system/index.vue'),
    children: [
      {
        path: "/zhengshu",
        component: () => import("@/views/menberWindow/system/zhengshu/index.vue"),
        meta: { hidden: true },
      },
      {
        path: "/paymentRecord",
        component: () => import("@/views/menberWindow/system/paymentRecord/index.vue"),
        meta: { hidden: true },
      },
      {
        path: "/editInfo",
        component: () => import("@/views/menberWindow/system/editInfo/index.vue"),
        meta: { hidden: true },
      },
    ]
  },
  // 搜索结果页面
  {
    path: '/search',
    name: 'SearchResults',
    component: () => import("../views/search/SearchResults.vue"),
    meta: { title: '搜索结果' }
  },
  /** 404 */
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  // 微信二维码
  {
    path: '/weixin', // 路由路径
    name: 'Weixin',   // 路由名称（可选）
    component: () => import('../views/erweima/weixin.vue')
  },
  // 党建pdf预览
  {
    path: '/pdf-viewer',
    name: 'PdfViewer',
    component: PdfViewer,
    props: (route) => ({ pdfUrl: route.query.url }), // 通过 URL 参数传递 PDF 链接
  },
    // pdf预览
  {
    path: '/guizhang_pdfviewer',
    name: 'guizhang_pdfviewer',
    component: guizhang_pdfviewer,
    // props: (route) => ({ pdfUrl: route.query.url }), // 通过 URL 参数传递 PDF 链接
  },
  // 分支机构活动
  {
    path: '/huiyi',
    name: 'huiyi',
    component: () => import('../views/Branch/huiyi.vue')
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



export default router
